import { LINEAGE_NAME_BY_ID, PRODUCT_TYPE_NAME_BY_ID } from '../consts'
import { ProductAttributes } from '../redux/types/products'

export const productAttributesLinter = (attributes: ProductAttributes) => ({
  amount: attributes.amount || '-',
  brand: attributes.brand || '-',
  brand_id: attributes.brand_id || '-',
  brand_subtype: attributes.brand_subtype || '',
  dosage: attributes.dosage || '-',
  lineage: LINEAGE_NAME_BY_ID[attributes.lineage] || '',
  matched_name: attributes.matched_name,
  matched_name_is_alias: attributes.matched_name_is_alias || false,
  name: attributes.name,
  product_subtype: attributes.product_subtype || '-',
  product_type: PRODUCT_TYPE_NAME_BY_ID[attributes.product_type] || '-',
  removal_status: attributes.removal_status || null,
  notice_status: attributes.notice_status || null,
  store_count: attributes.store_count || null,
  request_uuid: attributes.request_uuid,
  url: attributes.url,
})
